import { createContext, useContext, useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

const TripContext = createContext(null);
const STORAGE_KEY = "crossroad_selected_trip";

export function TripProvider({ children }) {
  const { data: trips = [] } = useQuery({
    queryKey: ["trips"],
    queryFn: async () => (await api.get("/trips")).data,
  });

  const [tripId, setTripIdState] = useState(() => localStorage.getItem(STORAGE_KEY) || "");

  const setTripId = (id) => {
    setTripIdState(id);
    if (id) localStorage.setItem(STORAGE_KEY, id);
    else localStorage.removeItem(STORAGE_KEY);
  };

  // Sélection par défaut : premier séjour si aucune sélection valide (hors "all")
  useEffect(() => {
    if (!trips.length) return;
    const valid = tripId === "all" || trips.some((t) => t.id === tripId);
    if (!valid) setTripId(trips[0].id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trips]);

  return (
    <TripContext.Provider value={{ trips, tripId, setTripId, isAll: tripId === "all" }}>
      {children}
    </TripContext.Provider>
  );
}

export function useTrip() {
  const ctx = useContext(TripContext);
  return ctx || { trips: [], tripId: "", setTripId: () => {}, isAll: false };
}
